import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { MaterialModule } from '../../shared/material.module';
import { SharedModule } from '../../shared/shared.module';

export type SnackbarState = 'success' | 'error' | 'warning' | 'info';

export interface SnackbarData {
  message: string;
  state?: SnackbarState;
}

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [CommonModule, SharedModule, MaterialModule],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  snackBarActions = MatSnackBarActions;
  snackBarAction = MatSnackBarAction;
  snackBarLabel = MatSnackBarLabel;
  public snackbarData: SnackbarData = inject(MAT_SNACK_BAR_DATA);
  public state: SnackbarState = this.snackbarData.state || 'success';
  public message: string =
    typeof this.snackbarData === 'string' ? this.snackbarData : this.snackbarData.message;

  getIconClass(): string {
    const iconMap: Record<SnackbarState, string> = {
      success: 'fa-circle-check',
      error: 'fa-circle-xmark',
      warning: 'fa-triangle-exclamation',
      info: 'fa-circle-info',
    };
    return iconMap[this.state] || iconMap.info;
  }
}
